import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Star, Quote } from 'lucide-react';
import { mockData } from '../mock';

const Testimonials = () => {
  return (
    <section className="py-16 md:py-24 bg-slate-50 relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-blue-600 font-bold text-xs md:text-sm uppercase tracking-wider">Anmeldelser</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 mt-4 mb-4 px-4">
            Hva kundene våre sier
          </h2>
          <p className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto px-4">
            Vi er stolte av å levere førsteklasses service
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mockData.testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="relative overflow-hidden hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-slate-200 bg-white">
              <div className="absolute top-4 right-4 text-blue-100">
                <Quote className="h-10 w-10" />
              </div>
              <CardContent className="pt-6 pb-6 relative">
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="text-slate-700 text-sm md:text-base leading-relaxed mb-6">
                  "{testimonial.text}"
                </p>
                <div className="border-t border-slate-200 pt-4">
                  <p className="font-bold text-slate-900 text-base">{testimonial.name}</p>
                  <p className="text-sm text-slate-500">{testimonial.location}</p>
                  <p className="text-xs text-blue-600 mt-1 font-medium">{testimonial.service}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
